import { atomWithStorage } from 'jotai/utils';

// Raw string storage — reads/writes the plain value without JSON.stringify wrapping.
// atomWithStorage's default storage uses JSON.stringify, which would store '"en-AU"'
// (with quotes) instead of 'en-AU', breaking the Axios interceptor and other non-React
// code that reads localStorage['lang'] directly expecting a bare string.
const rawStringStorage = {
  getItem:    (key: string): string        => localStorage.getItem(key) ?? 'en',
  setItem:    (key: string, value: string) => localStorage.setItem(key, value),
  removeItem: (key: string)                => localStorage.removeItem(key),
};

// Authoritative source for the active language code (full ISO, e.g. 'en', 'en-AU', 'hr').
// Persisted to localStorage['lang'] — the same key used by the Axios interceptor and
// non-React code, so both paths always agree on the current language.
// Initialised from localStorage on startup so existing user preferences are preserved.
export const currentLangAtom = atomWithStorage<string>('lang', 'en', rawStringStorage);
